import { FC, useEffect } from 'react';
import { createPortal } from 'react-dom';
import Button from '@srm/ui/button';

/**
 * Подтверждение действия в стиле Modal, но БЕЗ блокирующего оверлея: фон не
 * затемняется и остаётся кликабельным (клик вне карточки закрывает попап,
 * не съедая клик), Esc — отмена. Карточка — портал поверх страницы.
 */
const ConfirmPopup: FC<{
    title: string;
    text: string;
    okText?: string;
    cancelText?: string;
    onConfirm: () => void;
    onClose: () => void;
}> = ({ title, text, okText = 'ОК', cancelText = 'Отмена', onConfirm, onClose }) => {
    useEffect(() => {
        const onKey = (e: KeyboardEvent) => {
            if (e.key === 'Escape') onClose();
        };
        // capture: клик вне карточки закрывает попап, сам клик доходит до цели
        const onPointerDown = (e: PointerEvent) => {
            if (!(e.target as HTMLElement | null)?.closest('.tdn-confirm')) onClose();
        };
        window.addEventListener('keydown', onKey);
        window.addEventListener('pointerdown', onPointerDown, true);
        return () => {
            window.removeEventListener('keydown', onKey);
            window.removeEventListener('pointerdown', onPointerDown, true);
        };
    }, [onClose]);

    return createPortal(
        <div className="tdn-confirm" role="alertdialog" aria-label={title} data-testid="table-next-confirm">
            <div className="tdn-confirm__title">{title}</div>
            <div className="tdn-confirm__text">{text}</div>
            <div className="tdn-confirm__buttons">
                <Button
                    variant="primary"
                    size="sm"
                    aria-label={okText}
                    onClick={() => {
                        onClose();
                        onConfirm();
                    }}
                >
                    {okText}
                </Button>
                <Button variant="light" size="sm" aria-label={cancelText} onClick={onClose}>
                    {cancelText}
                </Button>
            </div>
        </div>,
        document.body,
    );
};

export default ConfirmPopup;
